








































helpers = require('../../helpers.coffee')

view_model = {
  components:
    tag: require('../tags/tag')

  props:
    business:
      type: Business

  data: ->
    {}

  computed:
    address: ->
      if @business.address
        short_address = @business.address?.substring(0,40)
        short_address+="..." if @business.address.length > 40
        short_address

    statusIconClass: ->
      switch @business.status
        when 'paused' then 'contact-event-subicon paused-icon'
        when 'active' then 'contact-event-subicon active-icon'
        when 'uninitialized' then 'contact-event-subicon uninitialized-icon'
        when 'scheduled_reactivation' then 'contact-event-subicon scheduled_reactivation-icon'
        else 'contact-event-subicon finished-icon'

    stageClasses: ->
      "btn-contact-stage btn-contact-fake contact-stage-#{@business.stage}"

    tag_first: ->
      return @business.tags[0] if @business.tags.length > 0

    tags_count_left: ->
      @business.tags.length - 1

    show_more_tags: ->
      @business.tags.length > 1

  methods:
    destroyBusiness: (event, attr = {}) ->
      event.originalEventName = 'business-destroy'
      @$emit 'business-destroy', { event, @business }

    editBusiness: ->
      @$router.push path: "/contatos/empresas/#{@business.id}"
}

exports.default = helpers.vue_include(view_model, helpers.contacts.styles, helpers.form)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/businesses/list_item.vue